import { render, staticRenderFns } from "./AddNewButton.vue?vue&type=template&id=1b286ab6&scoped=true"
var script = {}
import style0 from "./AddNewButton.vue?vue&type=style&index=0&id=1b286ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b286ab6",
  null
  
)

export default component.exports